import React, { Component } from 'react';
import './App.css';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import axios from "axios";
import { withSnackbar } from 'notistack';
import { bffUrl } from './config.js'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import SearchIcon from '@material-ui/icons/Search'
import { Grid, Button, Box, Select } from '@material-ui/core';
import { InputLabel } from '@material-ui/core'
import { MenuItem } from '@material-ui/core'
import { FormControl } from '@material-ui/core';




const styles = theme => ({
    container: {
        position: 'relative',
    },
});

let customFilterString = (filter, row) => {
    const id = filter.pivotId || filter.id;
    if (row[id] !== null && typeof row[id] === "string") {
        return (row[id] !== undefined
            ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
            : true);
    }
};

const columnDefs = [
    {
        Header: "Status", accessor: "status",
        width: 150,
        filterMethod: customFilterString
    },
    {
        Header: "CID", accessor: "cid",
        width: 100
    },
    {
        Header: "SCID", accessor: "scid",
        width: 100
    },
    {
        Header: "Product ID", accessor: "productid",
        width: 300
    },
    {
        Header: "Job ID", accessor: "jobid",
        width: 60
    },
    {
        Header: "Feed Type", accessor: "feed_type",
        width: 100
    },
    {
        Header: "Ingested", accessor: "ingested",
        width: 80
    },
    {
        Header: "Clip Title", accessor: "clip_title",
        width: 300,
        filterMethod: customFilterString
    },
    {
        Header: "Meta",
        accessor: "meta",
        Cell: props => <span className='number'>{(props.value && parseInt(props.value) ?
            <Typography color={'primary'}>1</Typography> : <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "Subs",
        accessor: "srt",
        Cell: props => <span className='number'>{(props.value && parseInt(props.value) ?
            <Typography color={'primary'}>1</Typography> : <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "Low",
        accessor: "low_res",
        Cell: props => <span className='number'>{((props.value) ? <Typography color={'primary'}>1</Typography> :
            <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "High",
        accessor: "high_res",
        Cell: props => <span className='number'>{((props.value) ? <Typography color={'primary'}>1</Typography> :
            <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "Create Time", accessor: "createtime",
        width: 200
    },
    {
        Header: "Low Start", accessor: "low_res_start_date",
        width: 120
    },
    {
        Header: "Low End", accessor: "low_res_end_date",
        width: 120
    },

    {
        Header: "High Start", accessor: "high_res_start_date",
        width: 120
    },
    {
        Header: "High End", accessor: "high_res_end_date",
        width: 120
    },

];
const columnSorting = [
    {
        Header: "Status", accessor: "status",
        width: 150,
        filterMethod: customFilterString
    },
    {
        Header: "CID", accessor: "cid",
        width: 100
    },
    {
        Header: "SCID", accessor: "scid",
        width: 100
    },
    {
        Header: "Product ID", accessor: "productid",
        width: 300
    },
    {
        Header: "Job ID", accessor: "jobid",
        width: 60
    },
    {
        Header: "Feed Type", accessor: "feed_type",
        width: 100
    },
    {
        Header: "Ingested", accessor: "ingested",
        width: 80
    },
    {
        Header: "Clip Title", accessor: "clip_title",
        width: 300,
        filterMethod: customFilterString
    },
    {
        Header: "Meta",
        accessor: "meta",
        Cell: props => <span className='number'>{(props.value && parseInt(props.value) ?
            <Typography color={'primary'}>1</Typography> : <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "Subs",
        accessor: "srt",
        Cell: props => <span className='number'>{(props.value && parseInt(props.value) ?
            <Typography color={'primary'}>1</Typography> : <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "Low",
        accessor: "low_res",
        Cell: props => <span className='number'>{((props.value) ? <Typography color={'primary'}>1</Typography> :
            <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "High",
        accessor: "high_res",
        Cell: props => <span className='number'>{((props.value) ? <Typography color={'primary'}>1</Typography> :
            <Typography color={'error'}><b>0</b></Typography>)}</span>,
        width: 50
    },
    {
        Header: "Create Time", accessor: "createtime",
        width: 200
    },
    {
        Header: "Low Start", accessor: "low_res_start_date",
        width: 120
    },
    {
        Header: "Low End", accessor: "low_res_end_date",
        width: 120
    },

    {
        Header: "High Start", accessor: "high_res_start_date",
        width: 120
    },
    {
        Header: "High End", accessor: "high_res_end_date",
        width: 120
    },

];

class SimulcastHelperContainer extends Component {

    constructor(props) {

        super(props);

        this.state = {
            cid: '',
            contentId: '',
            downloadableSourceUrlData: [],
            refreshMinutes: 10,
            simulcastData: [],
            columnDefs: columnDefs,
            columnSorting:columnSorting,
            INGESTION_TOOL: true,
            searchQuery: '',
            filterById: '',
            searchedResults: null,
            formError: false,
            formErrorMessage: ''
        };

    }

    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };
    onClearButtonSubmit = () => {
        this.setState({
            searchedResults: null,
            searchQuery: '',
            filterById: '',
            formError: false,
            formErrorMessage: ''


        })
    }
    handleValidation = (event) => {
        event.preventDefault()
        let integerKeys = ['cid', 'scid', 'jobid']
        if (integerKeys.includes(this.state.filterById)) {
            const pattern = /^\d+$/
            if (!(pattern.test(this.state.searchQuery))) {
                this.setState({ formError: true, formErrorMessage: 'Only integer value is allowed' })
            }
            else {
                this.setState({ formError: false, formErrorMessage: '' })
                this.handleSubmit()
            }
        }
        else {
            this.setState({ formError: false, formErrorMessage: '' })
            this.handleSubmit()
        }
    }
    handleSearchChange = event => {
        console.log(event.target.name)
        this.setState({
            [event.target.name]: String(event.target.value).trim()
        })
    };

    handleSubmit = async () => {
        try {

            const { data } = await axios.post(`${bffUrl}/ingestion/getFilteredData`, {
                "key": this.state.filterById,
                "value": this.state.searchQuery
            })
            this.setState({ searchedResults: data })
        }
        catch (error) {
        }
    };

    componentDidMount() {
        this.requestsLoader();

        if (sessionStorage.INGESTION_TOOL == "true") {
            this.setState({ INGESTION_TOOL: true });
        }


        let self = this;
        window.addEventListener('storage', (event) => {
            console.log(event);
            if (event.key && event.key === "INGESTION_TOOL") {
                if (event.newValue && event.newValue == "true") {
                    self.setState({ INGESTION_TOOL: true })
                } else if (event.newValue && event.newValue == "false") {
                    self.setState({ INGESTION_TOOL: false })
                }
            }
        })
    }

    snackBarCloseHandler = () => {
        this.setState({
            snackBarOpen: false
        })
    };

    requestsLoader = () => {

        const downloadRequestUrl = `${bffUrl}/ingestion/getSimulcastData`;
        const getDownloadRequest = axios.create({
            baseURL: downloadRequestUrl,
            timeout: 50000
        });
        getDownloadRequest.get()
            .then(response => {
                if (response.data) {

                    let simulResponse = (response.data);
                    this.setState({
                        simulcastData: simulResponse
                    }, () => {

                    })

                } else {
                    this.props.enqueueSnackbar('Data Does not Exist.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar('Error Occurs During Process.', {
                    variant: 'warning', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            });

    };


    render() {
        const { classes, theme } = this.props;
        const flex = { flexGrow: 1 };


        let self = this;

        const { simulcastData, searchedResults } = this.state;

        return (
            <React.Fragment>

                {(this.state.INGESTION_TOOL === true || sessionStorage.userEmail === "pooja.datrange@vuclip.com") &&
                    <React.Fragment>
                        {simulcastData && simulcastData.length > 0 &&
                            <React.Fragment>
                                <form onSubmit={this.handleValidation}>
                                    <Box sx={{ marginBottom: '20px' }}>
                                        <h2>Search below for previous data</h2>
                                        <Grid container alignItems='center' spacing={2}>
                                            <Grid item xs={1}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Filter by</InputLabel>
                                                    <Select required autoComplete='off'
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={this.state.filterById}
                                                        label="Filter by" name='filterById'
                                                        onChange={this.handleSearchChange}
                                                    >
                                                        <MenuItem value={'productid'}>PRODUCT ID</MenuItem>
                                                        <MenuItem value={'cid'}>CID</MenuItem>
                                                        <MenuItem value={'scid'}>SCID</MenuItem>
                                                        <MenuItem value={'jobid'}>JOB ID</MenuItem>
                                                        <MenuItem value={'clip_title'}>CLIP TITLE</MenuItem>

                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>

                                        <Grid container alignItems='center' spacing={2}>
                                            <Grid item xs={4}>
                                                <TextField name='searchQuery' autoComplete='off'
                                                    fullWidth required
                                                    error={this.state.formError}

                                                    inputProps={{
                                                        minLength: 4

                                                    }}
                                                    size="medium"
                                                    variant="outlined"
                                                    value={this.state.searchQuery}
                                                    onChange={this.handleSearchChange}
                                                />
                                            </Grid>

                                            <Grid item>
                                                <Button type='submit' style={{ minHeight: '50px', minWidth: '90px', padding: '8px 12px' }} color="primary" size="large" variant="contained">Search</Button>
                                            </Grid>
                                            <Grid>
                                                <Button style={{ minHeight: '50px', minWidth: '90px', padding: '8px 12px' }} color="primary" size="large" variant="contained" onClick={() => window.location.reload()}>Refresh</Button>
                                            </Grid>
                                            {this.state.searchedResults ? <Grid item>
                                                <Button type='submit' style={{ minHeight: '50px', minWidth: '90px', padding: '8px 12px' }} color="primary" size="large" variant="contained" onClick={this.onClearButtonSubmit}>Clear</Button>
                                            </Grid> : null}
                                        </Grid>
                                        {this.state.formError ? <p style={{ color: 'red' }}>{this.state.formErrorMessage}</p> : null}
                                    </Box>
                                </form>
                                {/* first react table */}
                                {this.state.searchedResults ?
                                    <Box sx={{ marginBottom: '40px' }}>
                                        {this.state.searchedResults.length ?
                                            <React.Fragment>

                                                <ReactTable
                                                    minRows={0}
                                                    filterable
                                                    data={searchedResults}
                                                    columns={this.state.columnSorting}
                                                />
                                            </React.Fragment>
                                            : <Typography variant={"h5"}>
                                                Data not Found</Typography>}

                                    </Box> :


                                    <Box sx={{ marginBottom: '30px' }}>
                                        <React.Fragment>
                                            <h2>The following table contains last one month data</h2>
                                            <ReactTable
                                                filterable
                                                data={simulcastData}
                                                columns={this.state.columnDefs}
                                            /></React.Fragment>

                                    </Box>}
                            </React.Fragment>}
                        {simulcastData && simulcastData.length === 0 &&
                            <Typography variant={"h5"}>
                                Data is loading, Please wait...
                            </Typography>}
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}


SimulcastHelperContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar(withStyles(styles, { withTheme: true })(SimulcastHelperContainer));
